import { DealRejectionReasonType, DealStatus } from '../deal';
import { ProcessingCountersType } from '.';

/**
 * Преобразует статус сделки (и при необходимости причину отклонения)
 * в тип счётчика для обработки/фильтрации.
 *
 * @param status Статус сделки.
 * @param rejectionReason Причина отклонения (актуально для отклонённых сделок).
 * @returns Тип счётчика, соответствующий переданному статусу.
 */
export const statuses2CountersType = (status: DealStatus, rejectionReason?: DealRejectionReasonType): ProcessingCountersType => {
  if (status === DealStatus.Accepted) {
    return ProcessingCountersType.Accepted;
  }
  if (status === DealStatus.Completed) {
    return ProcessingCountersType.Completed;
  }
  if (status === DealStatus.Negotiation) {
    return ProcessingCountersType.Negotiation;
  }
  if (status === DealStatus.InProgress) {
    return ProcessingCountersType.InProgress;
  }
  if (status === DealStatus.Rejected && !rejectionReason) {
    return ProcessingCountersType.RejectedByExpired;
  }
  if (status === DealStatus.Rejected && rejectionReason === DealRejectionReasonType.TimeForNegotiationExpired) {
    return ProcessingCountersType.RejectedByExpired;
  }
  if (status === DealStatus.Rejected && rejectionReason === DealRejectionReasonType.ClientDecision) {
    return ProcessingCountersType.RejectedByClient;
  }
  return ProcessingCountersType.Negotiation;
};

/**
 * Преобразует тип счётчика в соответствующий статус сделки.
 *
 * @param type Тип счётчика.
 * @returns Статус сделки, соответствующий указанному типу счётчика.
 */
export const countersType2Status = (type: ProcessingCountersType): DealStatus => {
  switch (type) {
    case ProcessingCountersType.RejectedByClient:
    case ProcessingCountersType.RejectedByExpired:
      return DealStatus.Rejected;
    case ProcessingCountersType.Accepted:
      return DealStatus.Accepted;
    case ProcessingCountersType.Completed:
      return DealStatus.Completed;
    case ProcessingCountersType.InProgress:
      return DealStatus.InProgress;
    case ProcessingCountersType.Negotiation:
      return DealStatus.Negotiation;
    default:
      return DealStatus.Negotiation;
  }
};

/**
 * Возвращает причину отклонения сделки для указанного типа счётчика.
 *
 * @param type Тип счётчика.
 * @returns Причина отклонения или `undefined`, если для данного типа причины отклонения нет.
 */
export const countersType2RejectionReason = (type: ProcessingCountersType): DealRejectionReasonType | undefined => {
  switch (type) {
    case ProcessingCountersType.RejectedByClient:
      return DealRejectionReasonType.ClientDecision;
    case ProcessingCountersType.RejectedByExpired:
      return DealRejectionReasonType.TimeForNegotiationExpired;
    default:
      return;
  }
};
